scheduleNotify